export function formateaEsfera(esfera) {
  const signo = (esfera < 0.00) ? '-' : '+';
  const zero = (Math.abs(esfera) < 10.00) ? '0' : '';
  const valorSinSigno = Math.abs(esfera).toFixed(2);
  return (signo + zero + valorSinSigno);
}
export function transponer(graduacion) {
  const graduacionTranspuesta = { ...graduacion };
  const cilindroLejos = graduacion.cilindro_lejos;
  if (cilindroLejos < 0.0) {
    const eje_lejos = parseFloat(graduacion.eje_lejos);
    graduacionTranspuesta.eje_lejos = (eje_lejos > 90.0) ? eje_lejos - 90 : eje_lejos + 90;
    graduacionTranspuesta.eje_lejos += 'º';
    const esfera_lejos = graduacion.esfera_lejos && graduacion.esfera_lejos !== '' ? parseFloat(graduacion.esfera_lejos) : 0;
    graduacionTranspuesta.esfera_lejos = formateaEsfera(esfera_lejos + cilindroLejos);
    graduacionTranspuesta.cilindro_lejos = formateaEsfera(-cilindroLejos);
    graduacionTranspuesta.transposicion = true;
  }
  const cilindroCerca = graduacion.cilindro_cerca;
  if (cilindroCerca < 0.0) {
    const eje_cerca = parseFloat(graduacion.eje_cerca);
    graduacionTranspuesta.eje_cerca = (eje_cerca > 90.0) ? eje_cerca - 90 : eje_cerca + 90;
    graduacionTranspuesta.eje_cerca += 'º';
    const esfera_cerca = graduacion.esfera_cerca && graduacion.esfera_cerca !== '' ? parseFloat(graduacion.esfera_cerca) : 0;
    graduacionTranspuesta.esfera_cerca = formateaEsfera(esfera_cerca + cilindroCerca);
    graduacionTranspuesta.cilindro_cerca = formateaEsfera(-cilindroCerca);
    graduacionTranspuesta.transposicion = true;
  }
  return graduacionTranspuesta;
}
export function getLabelGraduacion(grad) {
  return `E.L.${grad.esfera_lejos},${grad.cilindro_lejos},${grad.eje_lejos},E.C. ${grad.esfera_cerca}, A. ${grad.adicion}`;
}
